module.exports = __webpack_public_path__ + "img/bule10.02405d83.png";